export default {
	"6ae2087a39450e7c22da0d16d7649fd1": "提示",
	"879fec06ccfe97dc0ccd40d6753d4ea9": "暫不解綁",
	"0d50282e0f3530aa98804b69b3862964": "解綁賬號",
	"ec21d9ecb931b185b3828e4c2529c92a": "根據國家政策要求，發往台灣地區的快件需填寫證件號碼，請您補充填寫",
	"90ed3dbbea5261a517d1c1eefba4a3f8": "取消",
	"6858786ff5eae6ee8331ded3dd5b88ee": "去補充",
	"f956b08ed77c62d8a236002533993633": "抱歉，價格已發生變化!",
	"6d20ed71e31f315ebff227d96605fdda": "抱歉，創建訂單失敗！",
	"0acd53438c56e1f86a95786c4e76da12": "系統錯誤"
}
